<template>
  <div class="settings__item">
    <h3 class="settings__item-title" v-if="setting.title">
      {{ setting.title }}
    </h3>
    <section class="form">
      <div class="form__item">
        <span class="form__item-label">
          {{ setting.labelOne }}
        </span>

        <div class="form__item-input-container">
          <input
            class="form__item-input"
            type="text"
            @change="updateUser(setting)"
            @input="formatValue(setting)"
            @blur="formatNumber(setting)"
            maxlength="10"
            v-model.number="setting.firstValue"
            @focus="$parent.message = ''"
            placeholder="SEK"
          >
          <span class="form__item-input-unit"> kr</span>
        </div>
      </div>
      <!-- Temporary
      <div class="form__item">
        <span class="form__item-label"> {{ setting.labelTwo }} </span>
        <div class="form__item-input-container">
          <input
            class="form__item-input"
            type="text"
            @change="updateUser(setting)"
            @input="formatPercent(setting)"
            maxlength="2"
            v-model.number="setting.secondValue"
            @focus="$parent.message = ''"
            placeholder="0"
          >
          <span class="form__item-input-unit">procent</span>
        </div>
      </div> -->
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SettingsItem',
  props: {
    setting: Object
  },
  methods: {
    ...mapActions(['updateUser']),
    formatValue (item) {
      item.firstValue = item.firstValue.toString();
      item.firstValue = item.firstValue.replace(/[^0-9]/g,"");
    },
    formatPercent (item) {
      item.secondValue = item.secondValue.toString();
      item.secondValue = item.secondValue.replace(/[^0-9.-]/g,"");
    },
    formatNumber (item) {
      item.firstValue = item.firstValue.toString();
      item.firstValue = item.firstValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }
}
</script>

<style lang="scss" scoped>
.settings__item {
  @extend %column;
  margin: 0 0 4em 0;

  &-title {
    margin-bottom: 1rem;
  }

  .form {
    display: flex;
    flex-direction: column;
    background: $light;
    width: 100%;
    padding: 2rem;
    border-radius: $borderRadius;

    > div:not(:first-of-type) {
      margin-top: 2rem;
    }

    &__item {
      @extend %column;

      &-label {
        margin-bottom: .5em;
      }

      &-input-container {
        border: 1px solid #707070;
        display: flex;
        flex-direction: row;
        align-items: center;
        background-color: $white;
        border-radius: 2px;
      }

      &-input {
        width: 100%;
        border: none;
        outline: none;
        font-size: 1rem;
        padding: 1rem;

        &-unit {
          font-size: 1rem;
          padding: 0 10px;
        }
      }
    }
    @include breakpoints(medium) {
      flex-direction: row;

      > div:not(:first-of-type) {
        margin-top: auto;
      }

      &__item {
        &-label {
          margin: 0 0 1em 0;
        }
      }
    }
  }
}

.gathering2 {
  .settings__item {
    margin: 0;
  }

  .form {
    padding: 1rem 0;

    &__item {
      width: 100%;
    }
  }
}
</style>